<div class="add-button" [ngClass]="{'disabled': disabled}" (click)="handleClick($event)" [ngStyle]="getButtonStyle()">
    <i class="pi pi-plus"></i>
</div>